export default "__VITE_ASSET__74fbe7fa__"